module.exports = __webpack_public_path__ + "img/icon-add_r.164b4a9b.svg";